export interface NavbarPalette {
  'navbar-background': string;
  'navbar-box-shadow': string;
  'navbar-item': string;
  'navbar-item-hover': string;
  'navbar-item-hover-background': string;
  'navbar-item-active': string;
  'navbar-item-active-background': string;
  'navbar-burger': string;
  'navbar-dropdown-item': string;
  'navbar-dropdown-background': string;
  'navbar-dropdown-arrow': string;
  'navbar-dropdown-boxed-shadow': string;
  'navbar-dropdown-item-hover': string;
  'navbar-dropdown-item-hover-background': string;
  'navbar-dropdown-item-active': string;
  'navbar-dropdown-item-active-background': string;
  'navbar-divider-background': string;
  'navbar-item-link': string;
  'navbar-item-link-focus-hover-active-background': string;
  'navbar-item-link-focus-hover-active': string;
  'navbar-item-link-border': string;
  'navbar-item-link-circle-background': string;
}
